import { render } from "./Categories-edit.vue?vue&type=template&id=41b33ade"
import script from "./Categories-edit.vue?vue&type=script&lang=js"
export * from "./Categories-edit.vue?vue&type=script&lang=js"

import "./Categories-edit.vue?vue&type=style&index=0&id=41b33ade&lang=css"

import exportComponent from "/home/runner/work/nutristudents-k12-container/nutristudents-k12-container/.vapor/build/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__